<div class="bar-chart-wrapper">
  <div [class.loaded]="!isLoading && !errorText" class="bar-chart" #barChart data-test="bar-chart"></div>
  <twaice-fe-progress-spinner
    [spinnerSize]="40"
    *ngIf="isLoading && !errorText"
    [overlay]="true"
    data-test="data-loading"
  ></twaice-fe-progress-spinner>
  <span *ngIf="errorText" class="error-container" data-test="data-error">{{ errorText }}</span>
</div>
